import { DecimalPipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MaskWordCharsPipe } from '@rma/dashboard/generic/util/pipes/mask-word-chars';
import { RmaIconComponent, RmaIcons } from '@rma/generic/ui/icon';

@Component({
  selector: 'rma-stat-block',
  templateUrl: './stat-block.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DecimalPipe, MaskWordCharsPipe, RmaIconComponent, NgClass],
})
export class StatBlockComponent implements OnChanges {
  @HostBinding('class')
  public readonly classes = 'flex flex-col items-start gap-2';

  @Input()
  public title: string;

  @Input()
  public value: number | string | undefined;

  @Input()
  public blurb: string;

  @Input()
  public isBlurbDark = false;

  @Input()
  public maskValue = false;

  @Input()
  public icon: Extract<RmaIcons, 'ads_click' | 'favorite' | 'visibility'>;

  @Input()
  public blur: boolean;

  protected isNumber = true;

  ngOnChanges(changes: SimpleChanges): void {
    const { value } = changes;

    if (value && this.value) {
      this.isNumber = !(typeof this.value === 'string');
    }
  }
}
